interface FractionDetectableConceptType {
  baseXsdType?: string | null;
  baseXbrliType?: string | null;
  typeQname?: string | null;
}

const localPart = (qname: string | null | undefined): string | null => {
  if (!qname) return null;
  const afterBrace = qname.includes('}') ? qname.slice(qname.lastIndexOf('}') + 1) : qname;
  return afterBrace.includes(':') ? afterBrace.slice(afterBrace.lastIndexOf(':') + 1) : afterBrace;
};

// Fraction-ness must survive the jsonArelle base-type collapse (same trap as
// perShareItemType): check both vocabularies AND the typeQname localPart.
export const isFractionConceptType = (conceptType: FractionDetectableConceptType | null | undefined): boolean => {
  if (!conceptType) return false;
  const normalize = (t: string | null | undefined) => (t ?? '').replace(/ItemType$/, '');
  if (normalize(conceptType.baseXsdType) === 'fraction') return true;
  if (normalize(conceptType.baseXbrliType) === 'fraction') return true;
  return localPart(conceptType.typeQname) === 'fractionItemType';
};
